import script from "./MobileStory .vue?vue&type=script&lang=ts&setup=true"
export * from "./MobileStory .vue?vue&type=script&lang=ts&setup=true"

import "./MobileStory .vue?vue&type=style&index=0&id=be636fe2&scoped=true&lang=less"

import exportComponent from "D:\\sunrun_luo\\JK-neibu\\JKai-zhuzhan\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-be636fe2"]])

export default __exports__